import type {
  PickOutNearestExercise,
  PickOutOneExercise,
  PickOutOneWordBlock,
} from "@newpv/js-common"

export const getCorrectWordInExercise = (
  exercise: PickOutNearestExercise | PickOutOneExercise,
): PickOutOneWordBlock | undefined => exercise.words.find(word => word.isAnswer)
